export const SYSTEM_OBJECTS: Record<number, string> = {
    1: 'User',
    3: 'Employee',
    5: 'Task',
    7: 'Client',
    8: 'Vehicle',
    9: 'Location',
    13: 'CyclicTask',
    14: 'FuelTank',
};

export const SYSTEM_OBJECT_IDS: Record<string, number> = {
    User: 1,
    Employee: 3,
    Task: 5,
    Client: 7,
    Vehicle: 8,
    Location: 9,
    CyclicTask: 13,
    FuelTank: 14,
};
